import { AccordionButton, AccordionItem, AccordionPanel, Box, HStack, VStack } from "@chakra-ui/react";
import type { FC, ReactNode } from "react";

import { Text } from "@equidefi/ui";

type AccreditationMethodSectionProps = {
  title: string;
  description: string;
  onSelect?: () => void;
  children: ReactNode;
};

export const AccreditationMethodSection: FC<AccreditationMethodSectionProps> = ({
  title,
  description,
  onSelect,
  children,
}) => (
  <AccordionItem mb={4}>
    {({ isExpanded }) => (
      <>
        <AccordionButton onClick={onSelect} p={4} _hover={{}}>
          <HStack spacing={3} align="center" w="full" textAlign="left">
            <Box
              boxSize="24px"
              flexShrink={0}
              borderRadius="full"
              borderWidth="2px"
              borderColor={isExpanded ? "equidefi.blue" : "gray.300"}
              display="flex"
              alignItems="center"
              justifyContent="center">
              {isExpanded && <Box boxSize="12px" borderRadius="full" bg="equidefi.blue" />}
            </Box>
            <VStack align="start" spacing={2} flex={1}>
              <Text fontWeight="bold" fontSize="sm" m={0}>
                {title}
              </Text>
              <Text fontSize="xs" color="equidefi.darkGray" m={0}>
                {description}
              </Text>
            </VStack>
          </HStack>
        </AccordionButton>
        <AccordionPanel px={4} pt={0} pb={4}>
          {children}
        </AccordionPanel>
      </>
    )}
  </AccordionItem>
);
